//@flow
//Action Type Registered
export const NEMESIS_INV_SUBMIT_SUCCESS='NEMESIS_INV_SUBMIT_SUCCESS'
export const NEMESIS_INV_SUBMIT_ERROR='NEMESIS_INV_SUBMIT_ERROR'
export const NEMESIS_INV_SUBMITTED_COMPLETED='NEMESIS_INV_SUBMITTED_COMPLETED'
export const NEMESIS_EDIT_VERIFY_FORM_DATA_SUCCESS='NEMESIS_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const NEMESIS_EDIT_VERIFY_FORM_DATA_ERROR='NEMESIS_EDIT_VERIFY_FORM_DATA_ERROR'
export const NEMESIS_UPDATE_FORM_ERROR='NEMESIS_UPDATE_FORM_ERROR'
export const REFRESH_NEMESIS_CUSTOMERS_SUCCESS='REFRESH_NEMESIS_CUSTOMERS_SUCCESS'
export const REFRESH_NEMESIS_CUSTOMERS_ERROR='REFRESH_NEMESIS_CUSTOMERS_ERROR'
export const GET_NEMESIS_ITEMS_SUCCESS='GET_NEMESIS_ITEMS_SUCCESS';
export const GET_NEMESIS_ITEMS_ERROR='GET_NEMESIS_ITEMS_ERROR';
export const CREATE_NEW_NEMESIS_ITEM_SUCCESS='CREATE_NEW_NEMESIS_ITEM_SUCCESS';
export const CREATE_NEW_NEMESIS_ITEM_ERROR='CREATE_NEW_NEMESIS_ITEM_ERROR';
export const EDIT_NEMESIS_ITEM='EDIT_NEMESIS_ITEM';
export const UPDATE_NEMESIS_ITEM_SUCCESS='UPDATE_NEMESIS_ITEM_SUCCESS';
export const UPDATE_NEMESIS_ITEM_ERROR='UPDATE_NEMESIS_ITEM_ERROR';
export const MOVE_DOWN_NEMESIS_ITEM_SUCCESS='MOVE_DOWN_NEMESIS_ITEM_SUCCESS';
export const MOVE_DOWN_NEMESIS_ITEM_ERROR='MOVE_DOWN_NEMESIS_ITEM_ERROR';
export const MOVE_UP_NEMESIS_ITEM_SUCCESS='MOVE_UP_NEMESIS_ITEM_SUCCESS';
export const MOVE_UP_NEMESIS_ITEM_ERROR='MOVE_UP_NEMESIS_ITEM_ERROR';
export const DELETE_NEMESIS_ITEM_SUCCESS='DELETE_NEMESIS_ITEM_SUCCESS';
export const DELETE_NEMESIS_ITEM_ERROR='DELETE_NEMESIS_ITEM_ERROR';
export const SELECTED_NEMESIS_ITEM_ID='SELECTED_NEMESIS_ITEM_ID';
export const REFRESH_NEMESIS_ITEM='REFRESH_NEMESIS_ITEM';
export const OPEN_ADD_EDIT_LINEITEM_FORM='NEMESIS_OPEN_ADD_EDIT_LINEITEM_FORM'
export const CANCEL_ADD_EDIT_LINEITEN_FORM='NEMESIS_CANCEL_ADD_EDIT_LINEITEN_FORM'


// WEBPACK FOOTER //
// ./src/redux/nemesis/actionTypes.js